import React from 'react';

import { Card, Separator, Skeleton } from '@/_components';

export default function NotesListLoading() {
  return (
    <div className="flex h-full flex-col">
      {/* Messages container skeleton wrapped in Card */}
      <Card className="flex min-h-0 flex-1 flex-col">
        {/* Messages area skeleton */}
        <div className="min-h-0 flex-1">
          <div className="flex min-h-full flex-col p-4">
            {[1, 2, 3].map((i) => (
              <React.Fragment key={i}>
                <div className="flex flex-col gap-3 rounded-3xl p-4">
                  <div className="flex gap-3">
                    <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
                    <div className="flex min-w-0 flex-1 flex-col gap-2">
                      <div className="flex items-center gap-2">
                        <Skeleton className="h-4 w-24" />
                      </div>
                      <Skeleton className="h-3 w-16" />
                    </div>
                  </div>
                  <Skeleton className="mb-2 h-16 w-full" />
                </div>
                {i < 3 && <Separator className="my-4" />}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Input area skeleton */}
        <div className="bg-background border-c-border-muted shrink-0 border-t p-4">
          <div className="flex items-end gap-3">
            <Skeleton className="h-20 flex-1" />
            <Skeleton className="h-9 w-9 rounded-full" />
          </div>
        </div>
      </Card>
    </div>
  );
}
